
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/how-to-be-more-sustainable-this-christmas",
      function () {
        return require("private-next-pages/blog/how-to-be-more-sustainable-this-christmas.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/how-to-be-more-sustainable-this-christmas"])
      });
    }
  